import { PageHeader } from "@/components/common/States";
import InstrumentPayments from "@/components/insaat/InstrumentPayments";

export default function InsaatInstrumentReport() {
  return (
    <div data-testid="insaat-instrument-report-page">
      <PageHeader title="İnşaat Çek/Senet Raporu" subtitle="İnşaat Giderine Ver ile projelere verilen çek/senetler · vadesi gelmemiş evrak karşılıksız riskini taşır" testid="insaat-instrument-report-title" />
      <InstrumentPayments />
    </div>
  );
}
